import { useState, useRef, useEffect } from "react";
// ** Reactstrap Imports
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { BiLeftArrowAlt } from "react-icons/bi";
import axios from "axios";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { MdOutlineAdd, MdRemove } from "react-icons/md";
import ReactQuill from "react-quill";
import EditorToolbar, { modules, formats } from "../../utils/EditorToolbar";
import "react-quill/dist/quill.snow.css";
import useAuth from "../../hooks/useAuth";
import Select from "react-select";

const EditProduct = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();

  const options = [
    { value: "", label: "--Choose an option--", disabled: true },
    {
      value: "BUILDING & FACILITY MANAGEMENT",
      label: "BUILDING & FACILITY MANAGEMENT",
    },
    { value: "CONCIERGE", label: "CONCIERGE" },
    { value: "PROJECT & DEVELOPING", label: "PROJECT & DEVELOPING" },
    { value: "CLEANING", label: "CLEANING" },
    { value: "GARDENING & LANDSCAPING", label: "GARDENING & LANDSCAPING" },
  ];
  const [isEditMode, setIsEditMode] = useState(false);

  const [serviceInfo, setServiceInfo] = useState({});
  const fileInputRef = useRef();
  const [serviceImg, setServiceImg] = useState(null);
  const [mykey, setMyKey] = useState("");

  const [featureList, setFeatureList] = useState([
    { id: uuidv4(), servicesIncl: "" },
  ]);
  const [serviceType, setServiceType] = useState();

  const handleFeatureChange = (index, e) => {
    const { name, value } = e.target;
    const newInputFields = featureList.map((i) => {
      if (index === i.id) {
        i[name] = value;
      }
      return i;
    });

    setFeatureList(newInputFields);
  };

  const handleRemoveFeatureField = (index) => {
    const list = [...featureList];
    list.splice(index, 1);
    setFeatureList(list);
  };

  const handleAddFeatureField = () => {
    setFeatureList([...featureList, { id: uuidv4(), servicesIncl: "" }]);
  };

  const allFeatures = Array.prototype.map
    .call(featureList, function (item) {
      return item.servicesIncl;
    })
    .join("|");

  const ondescription = (value) => {
    setServiceInfo((prev) => {
      return {
        ...prev,
        serviceDesc: value,
      };
    });

    // setServiceInfo({ ...serviceInfo,
    //   serviceDesc: value
    // });
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (!file) {
        alert("please select an image");
      } else {
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
      }
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const addImage = async (e) => {
    setIsEditMode(true);

    const file = e.target.files[0];
    const base64Img = await convertToBase64(file);
    fileInputRef.current.value = base64Img;
    setServiceImg(e.target.files[0]);
  };

  const handleDropdownChange = (value) => {
    console.log(value);
    setServiceType(value.value);
  };

  const getData = async () => {
    try {
      await axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/services/find-service/${id}`,
          {
            headers: {
              Authorization: "Bearer " + auth.accessToken,
            },
          }
        )
        .then((res) => {
          setServiceInfo(res.data);
          setServiceImg(res.data && res.data.serviceImg);
          setServiceType({
            label: res.data.serviceType,
            value: res.data.serviceType,
          });

          let allFeat = [];
          res.data.servicesIncl.map((service) =>
            allFeat.push({ id: uuidv4(), servicesIncl: service })
          );
          setFeatureList(allFeat);
        });
    } catch (error) {
      console.log(error);
      error.response.data.message
        ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          })
        : toast.error(error.response.data.error, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          });
    }
  };

  useEffect(() => {
    getData();
  }, [id]);

  // ** States
  //  let initialState = serviceInfo;

  const handleChange = (event) => {
    const { value, name } = event.target;
    setServiceInfo((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };

  const handleUpdateClick = async (event) => {
    event.preventDefault();

    let serviceDesc = serviceInfo.serviceDesc;
    let serviceTagLine = serviceInfo.serviceTagLine;

    console.log("Type " + serviceType + "\t" + "Tagline " + serviceTagLine)

    const formData = new FormData();
    formData.append("serviceDesc", serviceDesc);
    formData.append("serviceType", serviceType.value);
    formData.append("servicesIncl", allFeatures);
    formData.append("serviceTagLine", serviceTagLine);
    formData.append("serviceImg", serviceImg);

    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/services/update-service/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + auth.accessToken,
          },
        }
      );
      toast.success(res.data.message, {
        className: "success-toast",
        autoClose: 3000,
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      navigate("/services/view");
    } catch (error) {
      error.response.data.message
        ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          })
        : toast.error(error.response.data.error, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          });
    }
  };

  const handleReset = async (event) => {
    event.preventDefault();
    navigate("/services/view");
  };

  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Update Service</h5>
      </Row>
      <Row sm="12">
        <Card>
          <CardBody>
            <Col sm="12" className="mb-2">
              <Form>
                <div className="mb-1">
                  <Label className="form-label" for="serviceType">
                    Service Type <span className="text-danger">*</span>
                  </Label>
                  <Select
                    isDisabled={true}
                    options={options}
                    className="serviceType"
                    value={serviceType}
                    // defaultValue={serviceType}
                    isOptionDisabled={(option) => option.disabled}
                    isSearchable="true"
                    onChange={handleDropdownChange}
                  />
                </div>

                <div className="mb-1">
                  <Label className="form-label" for="serviceTagLine">
                    Service Tagline <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="serviceTagLine"
                    type="text"
                    className="me-1"
                    name="serviceTagLine"
                    minLength={20}
                    maxLength={90}
                    required={true}
                    value={serviceInfo.serviceTagLine}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-1">
                  <Label className="form-label" for="serviceDesc">
                    Service Description <span className="text-danger">*</span>
                  </Label>
                  <EditorToolbar toolbarId={"t1"} />
                  <ReactQuill
                    id="serviceDesc"
                    theme="snow"
                    value={serviceInfo.serviceDesc}
                    onChange={ondescription}
                    placeholder={"Write something awesome..."}
                    modules={modules("t1")}
                    formats={formats}
                  />
                </div>

                <div className="mb-1">
                  <Label className="form-label" for="feature">
                    Service Feature <span className="text-danger">*</span>
                  </Label>
                  {featureList.map((inputField, index) => (
                    <Row key={inputField.id}>
                      <Col sm="12" md="10" lg="10">
                        <div>
                          <Input
                            id="feature"
                            type="text"
                            name="servicesIncl"
                            className="my-2"
                            value={inputField.servicesIncl}
                            onChange={(event) =>
                              handleFeatureChange(inputField.id, event)
                            }
                            required={true}
                          />
                        </div>
                      </Col>
                      <Col sm="12" md="1" lg="1">
                        <div className="mb-2">
                          {featureList && featureList.length - 1 === index && (
                            <Button
                              block
                              color="success"
                              className="my-2"
                              onClick={handleAddFeatureField}
                            >
                              <MdOutlineAdd />
                            </Button>
                          )}
                        </div>
                      </Col>
                      <Col sm="12" md="1" lg="1">
                        <div>
                          {featureList.length > 1 && (
                            <Button
                              block
                              color="danger"
                              className="my-2"
                              onClick={() => handleRemoveFeatureField(index)}
                            >
                              <MdRemove />
                            </Button>
                          )}
                        </div>
                      </Col>
                    </Row>
                  ))}
                </div>

                <div className="mb-1">
                  <Label className="form-label" for="serviceImg">
                    Image <span className="text-danger">(max size: 100KB, width: 577 x height 825)</span>
                  </Label>
                  <Input
                    id="serviceImg"
                    type="file"
                    className="me-1"
                    name="serviceImg"
                    accept="image/png, image/jpeg, image/jpg"
                    required={true}
                    key={mykey || ""}
                    ref={fileInputRef}
                    onChange={addImage}
                  />
                </div>
                {isEditMode ? (
                  <div className="mb-3 mt-3">
                    <div>
                      <img
                        style={{ width: 180 }}
                        src={
                          (fileInputRef &&
                            fileInputRef.current &&
                            fileInputRef.current.value) ||
                          ""
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div className="mb-3 mt-3">
                    <div>
                      {serviceImg && (
                        <img
                          style={{ width: 250 }}
                          src={`${
                            process.env.REACT_APP_API_IMAGE_URI.substring(
                              0,
                              process.env.REACT_APP_API_IMAGE_URI.indexOf(
                                "/api"
                              )
                            ) +
                            serviceImg.substring(serviceImg.indexOf("/uploads"))
                          }`}
                          alt="services-img"
                        ></img>
                      )}
                    </div>
                  </div>
                )}

                <Row className="pt-2">
                  <Col>
                    <div className="mb-1">
                      <Button
                        block
                        color="success"
                        type="submit"
                        onClick={handleUpdateClick}
                      >
                        Update
                      </Button>
                    </div>
                  </Col>
                  <Col>
                    <div className="mb-1">
                      <Button block color="warning" onClick={handleReset}>
                        Reset
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Col>
          </CardBody>
        </Card>
      </Row>

      <Row sm="12" className="mt-4 text-center">
        <Link to={"/services/view"} className="go_back">
          <BiLeftArrowAlt size={30} /> Go to service list
        </Link>
      </Row>
    </div>
  );
};

export default EditProduct;
